import { render, staticRenderFns } from "./mouthReportRecordList.vue?vue&type=template&id=4f884425&scoped=true"
import script from "./mouthReportRecordList.vue?vue&type=script&lang=js"
export * from "./mouthReportRecordList.vue?vue&type=script&lang=js"
import style0 from "./mouthReportRecordList.vue?vue&type=style&index=0&id=4f884425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f884425",
  null
  
)

export default component.exports